<pbc-filter [config]="ProjektStatiFilterConfig" [filter]="projektStati.filter$ | async" (filterChange)="projektStati.filter$.next($event)"></pbc-filter>
